import { useParams } from "react-router-dom";

import { VERSIONS } from "~/providers/constants";
import { PatientParams } from "~/providers/utils";
import {
  SummaryVersion,
  VersionedTypes,
} from "~/providers/utils/types/SummariesVersionsTypes";
import { PreviewSectionsV1 } from "./v1";
import { PreviewSectionsV2 } from "./v2";
import { PreviewSectionsV3 } from "./v3";
import { PreviewSectionsV4 } from "./v4";

export const previewVersions = {
  [VERSIONS.v1]: PreviewSectionsV1,
  [VERSIONS.v2]: PreviewSectionsV2,
  [VERSIONS.v3]: PreviewSectionsV3,
  [VERSIONS.v4]: PreviewSectionsV4,
} as const;

interface PatientPreviewSectionsProps<
  V extends SummaryVersion = SummaryVersion,
> {
  screeningSummary: VersionedTypes[V]["screening"];
  intakeSummary?: VersionedTypes[V]["intake"];
  version: V;
}

export const PatientPreviewSections = <V extends SummaryVersion>({
  screeningSummary,
  intakeSummary,
  version,
}: PatientPreviewSectionsProps<V>) => {
  const { patientId } = useParams<keyof PatientParams>() as PatientParams;

  const PreviewRenderer = previewVersions[version] as React.ComponentType<{
    patientId: string;
    screeningSummary: VersionedTypes[V]["screening"];
    intakeSummary?: VersionedTypes[V]["intake"];
  }>;

  return (
    <div className="flex flex-col gap-6 pb-6">
      <PreviewRenderer
        patientId={patientId}
        screeningSummary={screeningSummary}
        intakeSummary={intakeSummary}
      />
    </div>
  );
};
